// extracted by mini-css-extract-plugin
module.exports = {"collection-page":"collection_collection-page__3g7UF","title":"collection_title__3EmcP","items":"collection_items__39JvA","collection-item":"collection_collection-item__1L7rt"};